import { IconButton } from "@commonlibs";
import styled, { css, keyframes } from "styled-components";
import { REFRESH_ICON_ANIMATION_DURATION } from "./RefreshIconButton";

const rotate = keyframes`
  0% { transform: rotate(360deg); }
  100% { transform: rotate(0deg); }
`;

export const RefreshIconButtonRoot = styled(IconButton)<{ refreshing: boolean }>(
    ({ theme, refreshing }) => css`
        color: ${theme.palette.overlays["600"]["60"]};
        font-size: 1rem;
        display: flex;
        .Icon {
            font-size: 1.5rem;
        }
        ${refreshing &&
        css`
            animation: ${rotate} ${REFRESH_ICON_ANIMATION_DURATION}ms linear infinite;
        `}
    `,
);
